import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PoliticaContent } from "@/hooks/usePoliticasContent";
import { RichTextEditor } from "./RichTextEditor";
import { sanitizeHTML } from "@/utils/htmlSanitizer";

interface AddPoliticaDialogProps {
  open: boolean;
  onClose: () => void;
  onAdd: (politica: Omit<PoliticaContent, "id">) => void;
  nextOrderIndex: number;
}

export const AddPoliticaDialog = ({ open, onClose, onAdd, nextOrderIndex }: AddPoliticaDialogProps) => {
  const [content, setContent] = useState("");

  const handleAdd = () => {
    if (!content.trim()) return;

    const sanitizedContent = sanitizeHTML(content);
    const title = `Termos de Uso`;

    onAdd({
      order_index: nextOrderIndex,
      title,
      content: { html: sanitizedContent },
      is_visible: true,
    } as PoliticaContent);

    setContent("");
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto overflow-x-hidden">
        <DialogHeader>
          <DialogTitle>Criar novo termo de uso</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="content">Conteúdo</Label>
            <RichTextEditor
              content={content}
              onChange={setContent}
              placeholder="Digite o conteúdo aqui..."
            />
            <p className="text-xs text-muted-foreground">
              Use a barra de ferramentas para formatar o texto. Atalhos: Ctrl+B (negrito), Ctrl+I (itálico), Ctrl+K (link)
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancelar
          </Button>
          <Button onClick={handleAdd} disabled={!content.trim()}>
            Adicionar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
